import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './header-grid-cell.module.css'

export const HeaderGridCell = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {className, ...other} = props

  return <div role="columnheader" aria-colspan={1} className={clsx(className, styles.Box)} {...other} ref={ref} />
})

HeaderGridCell.displayName = 'HeaderGridCell'
